import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import { Modal } from "./modal.js";

function getArticleContent(title) {
  const { default: content } = require(`./assets/articles/${title}/${title}`);
  return content;
}

function Article() {
  const routerParams = useParams();
  const articleTitle = routerParams.articleTitle;
  const navigate = useNavigate();

  function onCloseModal() {
    navigate("/");
  }

  return (
    <Modal
      title={articleTitle}
      content={getArticleContent(articleTitle)}
      closeModal={onCloseModal}
    />
  );
}

export function ArticlesModal() {
  return (
    <Routes>
      <Route path=":articleTitle" element={<Article />} />
      <Route path="/" element={<></>} />
    </Routes>
  );
}
